/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';
import {themeSwitcher} from '@siemens/ix-angular';
import {LoginComponent} from '../../login/login.component';

@Component({
  selector: 'app-machine-login',
  templateUrl: './machine-login.component.html',
  styleUrl: './machine-login.component.scss',
  standalone: false,
})
export class MachineLoginComponent extends LoginComponent {
  protected readonly themeSwitcher = themeSwitcher;

  year: number = new Date().getFullYear();
}
